export const balloonSprite = {
  collisionData: {
    coords: [
      { x: 22, y: 0 },
      { x: 15, y: 5 },
      { x: 10, y: 10 },
      { x: 5, y: 15 },
      { x: 0, y: 22 },
      { x: 0, y: 39 },
      { x: 5, y: 49 },
      { x: 10, y: 56 },
      { x: 15, y: 61 },
      { x: 20, y: 68 },
      { x: 25, y: 73 },
      { x: 30, y: 78 },
      { x: 34, y: 85 },
      { x: 39, y: 92 },
      { x: 44, y: 99 },
      { x: 38, y: 101 },
      { x: 36, y: 104 },
      { x: 34, y: 116 },
      { x: 38, y: 119 },
      { x: 55, y: 119 },
      { x: 57, y: 116 },
      { x: 57, y: 104 },
      { x: 55, y: 101 },
      { x: 49, y: 99 },
      { x: 54, y: 92 },
      { x: 59, y: 85 },
      { x: 63, y: 78 },
      { x: 68, y: 73 },
      { x: 73, y: 68 },
      { x: 78, y: 61 },
      { x: 83, y: 56 },
      { x: 88, y: 49 },
      { x: 93, y: 39 },
      { x: 93, y: 22 },
      { x: 88, y: 15 },
      { x: 83, y: 10 },
      { x: 78, y: 5 },
      { x: 71, y: 0 },
    ],
    center: {
      x: 46,
      y: 59,
    },
  },
};

export const nautilusSprite = {
  collisionData: {
    coords: [
      { x: 0, y: 8 },
      { x: 4, y: 19 },
      { x: 8, y: 28 },
      { x: 2, y: 31 },
      { x: 7, y: 31 },
      { x: 9, y: 29 },
      { x: 12, y: 29 },
      { x: 14, y: 26 },
      { x: 16, y: 26 },
      { x: 18, y: 24 },
      { x: 28, y: 25 },
      { x: 30, y: 23 },
      { x: 29, y: 26 },
      { x: 36, y: 26 },
      { x: 38, y: 29 },
      { x: 41, y: 29 },
      { x: 42, y: 31 },
      { x: 47, y: 33 },
      { x: 51, y: 35 },
      { x: 62, y: 35 },
      { x: 65, y: 33 },
      { x: 67, y: 31 },
      { x: 70, y: 31 },
      { x: 71, y: 33 },
      { x: 73, y: 31 },
      { x: 78, y: 31 },
      { x: 78, y: 35 },
      { x: 103, y: 35 },
      { x: 104, y: 33 },
      { x: 111, y: 33 },
      { x: 112, y: 32 },
      { x: 117, y: 30 },
      { x: 120, y: 29 },
      { x: 125, y: 27 },
      { x: 129, y: 24 },
      { x: 138, y: 22 },
      { x: 140, y: 20 },
      { x: 145, y: 20 },
      { x: 147, y: 22 },
      { x: 149, y: 19 },
      { x: 149, y: 20 },
      { x: 147, y: 17 },
      { x: 145, y: 19 },
      { x: 140, y: 19 },
      { x: 138, y: 17 },
      { x: 134, y: 15 },
      { x: 129, y: 13 },
      { x: 125, y: 11 },
      { x: 120, y: 8 },
      { x: 116, y: 6 },
      { x: 111, y: 4 },
      { x: 104, y: 4 },
      { x: 102, y: 1 },
      { x: 100, y: 4 },
      { x: 99, y: 5 },
      { x: 95, y: 6 },
      { x: 93, y: 8 },
      { x: 91, y: 10 },
      { x: 71, y: 10 },
      { x: 69, y: 8 },
      { x: 66, y: 7 },
      { x: 65, y: 6 },
      { x: 60, y: 6 },
      { x: 61, y: 8 },
      { x: 60, y: 10 },
      { x: 33, y: 10 },
      { x: 31, y: 12 },
      { x: 29, y: 14 },
      { x: 13, y: 14 },
      { x: 12, y: 13 },
      { x: 10, y: 11 },
      { x: 8, y: 8 },
    ],
    center: {
      x: 74,
      y: 19,
    },
  },
};

export const obstacleHeadSprite = {
  collisionData: {
    coords: [
      { x: 0, y: 0 },
      { x: 0, y: 52 },
      { x: 14, y: 55 },
      { x: 83, y: 55 },
      { x: 99, y: 55 },
      { x: 99, y: 0 },
    ],
  },
};

export const bonusTypes = ['coin', 'heart'];

export const bgm = ['bgm1', 'bgm2', 'bgm3', 'bgm4', 'bgm5', 'bgm6'];

export const seaBgm = ['bgm_sea1', 'bgm_sea2', 'bgm_sea3', 'bgm_sea4', 'bgm_sea5'];

export const sfx = ['balloon_jump', 'change_level', 'coin', 'fast', 'game_over', 'heart', 'hit', 'nautilus_jump', 'score_point', 'start'];
